export default {"src":"/_next/static/media/vaessen.d00d955a.svg","height":172,"width":172,"blurWidth":0,"blurHeight":0};